type CalcResult = { width: number; height: number };

export class EditorCalc {
    private host = document.createElement("div");
    private box = document.createElement("div");

    constructor() {
        Object.assign(this.host.style, {
            position: "fixed",
            left: "-10000px",
            top: "0",
            visibility: "hidden",
            pointerEvents: "none",
            contain: "layout style paint",
            zIndex: "-1",
        } as CSSStyleDeclaration);

        Object.assign(this.box.style, {
            display: "inline-block",
            boxSizing: "border-box",
            whiteSpace: "pre-wrap",
            overflowWrap: "break-word",
            wordBreak: "keep-all",
        } as CSSStyleDeclaration);

        this.box.className = "ql-editor";

        this.host.appendChild(this.box);
        document.body.appendChild(this.host);
    }

    destroy() {
        this.host.remove();
    }

    measure(params: {
        html: string;
        styleSource: HTMLElement;
        minWidth: number;
        maxWidth: number;
        paddingX: number;
        paddingY: number;
        fontFamily?: string;
        styleOverrides?: {
            fontSize?: number;
            lineHeight?: number;
        };
    }): CalcResult {
        const cs = getComputedStyle(params.styleSource);

        const lineHeight = parseFloat(cs.lineHeight);

        this.box.style.fontSize = cs.fontSize;
        this.box.style.letterSpacing = cs.letterSpacing;
        this.box.style.lineHeight = cs.lineHeight;
        this.box.style.textAlign = cs.textAlign;
        this.box.style.setProperty("--circle-diameter", `${lineHeight / 5}px`);
        this.box.style.setProperty("--horizontal-padding", `${params.paddingX}px`);
        this.box.style.setProperty("--text-font-family", params.fontFamily || cs.fontFamily);

        this.box.style.minWidth = `${params.minWidth}px`;
        this.box.style.maxWidth = `${params.maxWidth}px`;
        this.box.style.padding = `${params.paddingY}px ${params.paddingX}px`;

        if (params.styleOverrides?.fontSize !== undefined) {
            this.box.style.fontSize = `${params.styleOverrides.fontSize}px`;
        }

        if (params.styleOverrides?.lineHeight !== undefined) {
            this.box.style.lineHeight = `${params.styleOverrides.lineHeight}px`;
        }

        this.box.innerHTML = normalizeForCalc(params.html);

        return {
            width: this.box.scrollWidth,
            height: this.box.scrollHeight,
        };
    }
}

function normalizeForCalc(html: string): string {
    return html
        .replace(/(>[^<]*?)([ \t]+)(<\/(p|li)>)/g, (_m, a, spaces, close) => {
            const n = spaces.length;
            const kept = " ".repeat(Math.max(0, n - 1));
            return `${a}${kept}\u00A0${close}`; // последний пробел = NBSP
        })
        .replace(/(<(p|li)\b[^>]*>)([\s\S]*?)(<\/\2>)/g, (_m, open, tag, content, close) => {
            const trimmed = content.trim();

            // Если блок заканчивается <br>, не добавляем ZWSP
            if (/<br\s*\/?>\s*$/i.test(trimmed)) {
                return `${open}${content}${close}`;
            }

            return `${open}${content}\u200B${close}`;
        });
}
